import { getItemWebStorage } from "src/features/webStorageSaver";
import ContentHeader from "../../widgets/contentHeader/ContentHeader";
import AddressInfo from "../../widgets/objectsOnMapPointInfo/AddressInfo";
import FederalRoadsInfo from "../../widgets/objectsOnMapPointInfo/federalRoadsInfo/FederalRoadsInfo";
import ObjectsInfo from "../../widgets/objectsOnMapPointInfo/objectsInfo/ObjectsInfo";
import RegionsInfo from "../../widgets/objectsOnMapPointInfo/regionsInfo/RegionsInfo";

export default function ObjectsOnMapPointInfo() {
    const currentConfig = getItemWebStorage("currentConfig");
    const objectsList = currentConfig?.objectsList
    const { isRegionsListShown, isFederalRoadsListShown } = objectsList ?? {}

    return (
        <>
            <ContentHeader title="Информация по объектам на карте" />
            <div className="objects-on-map-point-info-div">
                <AddressInfo />
                {isRegionsListShown && <RegionsInfo />}
                {isFederalRoadsListShown && <FederalRoadsInfo />}
                <ObjectsInfo />
            </div>
        </>
    )
}
